import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DashboardData } from '../models/dashboard-data';
import { Observable } from 'rxjs/Observable';
import { LocationGraphData } from '../models/location-graph-data';
import { TableData } from '../models/table-data';
import { GraphData } from '../models/graph-data';
import { CardData } from '../models/card-data';
import { Store } from '../components/charts/chart/map-chart/data/store';

@Injectable()
export class HttpService {

  dataSubject: BehaviorSubject<DashboardData[]> = new BehaviorSubject<DashboardData[]>([]);
  requestLocationDataSubject: BehaviorSubject<LocationGraphData[]> = new BehaviorSubject<LocationGraphData[]>([]);
  tableDataSubject: BehaviorSubject<TableData[]> = new BehaviorSubject<TableData[]>([]);
  graphDataSubject: BehaviorSubject<GraphData[]> = new BehaviorSubject<GraphData[]>([]);
  cardDataSubject: BehaviorSubject<CardData[]> = new BehaviorSubject<CardData[]>([]);

  constructor() { }

  public dashboardData(): Observable<DashboardData[]> {
    return this.dataSubject.asObservable();
  }
  public LocationGraphData(): Observable<LocationGraphData[]> {
    return this.requestLocationDataSubject.asObservable();
  }
  public graphData(): Observable<GraphData[]> {
    return this.graphDataSubject.asObservable();
  }
  public tableData(): Observable<TableData[]> {
    return this.tableDataSubject.asObservable();
  }
  public cardData(): Observable<CardData[]> {
    return this.cardDataSubject.asObservable();
  }

  public fetchData(): void {
    //console.log('fetching data...');

    //Dashboard
    let dashData = [
      new DashboardData('system-1', null, true, 67, new Date()),
      new DashboardData('system-1', 'component-2', null, 123),
      new DashboardData('system-2', 'errors', null, 7),
      new DashboardData('system-2', null, null, 35, new Date()),
      new DashboardData('system-3', null, null, 87, new Date()),
      new DashboardData('system-4', null, false, 13, new Date()),
      new DashboardData('system-4', 'errors', false, 3, new Date()),
      new DashboardData('system-5', null, true, 26, new Date()),

      new DashboardData('system-7', 'requests', true, 10, new Date()),
      new DashboardData('system-2', 'requests', null, 5),
      new DashboardData('system-4', 'requests', null, 3, new Date()),

      new DashboardData('SMS', 'Telekom', false, null, new Date()),
      new DashboardData('SMS app', 'Telekom', true, null, new Date()),
    ];

    // change random value every time for testing
    let rnd = Math.floor(Math.random() * dashData.length);
    dashData[rnd].value = Math.floor(Math.random() * 100);
    ////

    //Geo graph
    let requestLocationData = [
      new LocationGraphData('SI', 'Koper', 15000),
      new LocationGraphData('DE', 'Berlin', 1000),
      new LocationGraphData('LU', 'City', 775),
      new LocationGraphData('LU', 'City', 775),
      new LocationGraphData('LU', 'City', 775),
      new LocationGraphData('ES', 'City', 775),
      new LocationGraphData('LU', 'City', 775),
      new LocationGraphData('GB', 'City', 775),
      new LocationGraphData('NZ', 'City', 775),
      new LocationGraphData('US', 'City', 775),
      new LocationGraphData('LU', 'City', 775)
    ];
    //Other graphs
    let graphData = [
      new GraphData('graph1', null, new Date('2018-11-13T13:58:47+00:00'), Math.floor(Math.random() * 20)),
      new GraphData('graph2', null, new Date('2018-11-13T13:58:47+00:00'), Math.floor(Math.random() * 20)),
      new GraphData('graph3', null, new Date('2018-11-13T13:58:47+00:00'), Math.floor(Math.random() * 20)),
      new GraphData('graph4', null, new Date('2018-11-13T13:58:47+00:00'), Math.floor(Math.random() * 20)),
      new GraphData('graph5', null, new Date('2018-11-13T13:58:47+00:00'), Math.floor(Math.random() * 20)),
      new GraphData('graph6', null, new Date('2018-11-13T13:58:47+00:00'), Math.floor(Math.random() * 20))
    ]
    //Table
    let tableData = [
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1239998487712bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1234789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb12aabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1239789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg', 'aaffeeb1239998487712993774789912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg.usage.total.percent', 'aaffeeb12389912bcaabbaaefff'),
      new TableData(new Date('2018-11-13T13:58:47+00:00'), new Date('2018-11-13T13:58:47+00:00'), 74200, 'docker.cpu.avg', 'aaffeeb1239998487712993774789912bcaabbaaefff')
    ];
    //Service cards
    let cardData = [
      new CardData('SMS', 'Telekom', '51K', true),
      new CardData('SMS App', 'A1', 'Service down', false),
      new CardData('App CPU', 'BWS', '51K', true),
      new CardData('App RAM', 'BWS', '25%', true),
      new CardData('App RAM', 'Telekom', '34%', true),
      new CardData('App RAM', 'Telekom', '34%', true)
    ]

    this.dataSubject.next(dashData);
    this.requestLocationDataSubject.next(requestLocationData);
    this.graphDataSubject.next(graphData);
    this.tableDataSubject.next(tableData);
    this.cardDataSubject.next(cardData);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/http.service.ts